module.exports = __webpack_public_path__ + "static/media/Footer Adornment.45bb5f57.svg";